import { h, Component } from 'preact';
import { route } from 'preact-router';
import Match from 'preact-router/match';
import { BaseComponent } from '../../common/BaseComponent';
import { IHomeProps, IHomeState } from './IHome';

import Button from 'preact-material-components/Button';
import { bind } from 'decko';
import { DocumentFolder } from '../../components/documentFolder/documentFolder';
import { Folder } from '../../models/Folder';
import { WorkRequestList } from '../../components/WorkRequests/WorkRequestList';
import { TextValue } from '../../models/TextValue';


let style = require('./style.scss');

export class Home extends BaseComponent<IHomeProps, IHomeState> {
    constructor(props, ctx) {
        super(props, ctx);
        this.setState({
            isLoading : true
        })
    }

    @bind
    public onViewWorkRequests() {
        route(`/workrequests/`, true);
    }

    @bind
    public onViewDocumentation() {
        route(`/documents/`, true);
    }

    @bind
    public onSignout() {
        route(`/signout/${this.state.userStatus.checkedInId}`, true);
    }

    @bind
    public onRefresh() {
        this.setState({ userStatus: null, isLoading: true });
        this.loadData();
    }

    private loadData() {
        this.modal.showLoader(this.authService.checkUserStatus())
        .then(b => {
            this.setState({ userStatus: b.result, isLoading: false });

            if (b.errorMessage == "User GUID not found" || b.infoMessage == "User GUID not found") {
                this.modal.alert(b.errorMessage);
                this.auth.logout();
                route("/scanCode", true);
                return;
            }

            if (b.errorMessage) {
                this.modal.alert(b.errorMessage);
                return;
            }
            this.commonService.setHeaderImage(b.result.useHeaderImage);
            this.commonService.setFooterImage(b.result.useFooterImage);
            if (!b.result.checkedInId) {
                if (this.props.mode == "signInOut") {
                    route("/signin/" + this.props.buildingId + "/" + this.props.buildingName,true);
                }
                else
                    route("/scanCode", true);
                return;
            }
            if (this.props.mode == "signInOut" && this.props.buildingId == b.result.checkedInId) {
                route("/signout/" + this.props.buildingId, true);
            }
            //if (!b.result.building.documentFolder.folders.length) {
            //    b.result.building.documentFolder.folders.push(new Folder({ name: "test", documents: [], folders: [] }));
            //}

        }).catch(e => {           
            //this.modal.alert(e.errorMessage || e.message || e);
            
        });
    }

    componentDidMount() {
        this.loadData();
    }

    onStaticInformation(html: string): any {
        const el = <span dangerouslySetInnerHTML={{ __html: html }} />;
        this.modal.alert(el);
    }

    render() {
        return (
            <div>
                {this.state.isLoading ? ("") : this.props.mode == "documents" ? (
                    <DocumentFolder building={this.state.userStatus.building} currentPath={this.props.docpath} />
                ) : this.props.mode == "workrequests" ? (
                    <WorkRequestList
                        workRequests={this.state.userStatus.building.workRequests}
                        workRequestId={this.props.workrequestid}
                        actionButtons={this.state.userStatus.building.workRequestActionButtons}
                        buildingId={this.state.userStatus.checkedInId}
                        onRefresh={this.onRefresh}
                    />
                ) : (
                            <div>
                                <h3 class="text-center">You are currently {this.state.userStatus.sign}ed in to:</h3>
                                <h2 class="text-center">{this.state.userStatus.checkedInName}</h2>
                                <div class="text-center">Please remember to {this.state.userStatus.sign} out when you leave</div>
                                {this.state.userStatus.building.workRequestsTitle ?
                                    <div class={`${style.formField}`}>
                                        <Button raised ripple onClick={this.onViewWorkRequests}>{this.state.userStatus.building.workRequestsTitle}</Button>
                                    </div> : ""
                                }
                                {this.state.userStatus.building.documentsTitle ?
                                    <div class={`${style.formField}`}>
                                        <Button raised ripple onClick={this.onViewDocumentation}>{this.state.userStatus.building.documentsTitle}</Button>
                                    </div> : ""
                                }
                                {this.state.userStatus.building.staticInformationButtons?this.state.userStatus.building.staticInformationButtons.map((s) => {
                                    return <div class={`${style.formField}`}>
                                        <Button raised ripple onClick={() => { this.onStaticInformation(s.value); }}>{s.text}</Button>
                                    </div>
                                }):""}
                                <div class={`${style.formField}`}>
                                    <Button raised ripple onClick={this.onSignout}>{this.state.userStatus.sign} Out</Button>
                                </div>

                            </div>
                        )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./routes/home/home.tsx